import React from 'react'
import { Redirect, Switch, withRouter } from 'react-router-dom'

import RouteNotFound from '../../../RouteNotFound'
import PrivateRoute from '../../../../common-components/routes/PrivateRoute'

import EmployeeDashboard from './EmployeeDashboard'
import OperateAsCustomerUser from '../../../employee/OperateAsCustomerUser'

import { URL_PATHS } from '../../../../constants'
import KegCollectionBookings from '../../KegCollectionBookings'
import KegCollectionBookingsDetails from '../../KegCollectionBookings/components/KegCollectionBookingDetails/'
import { isFeatureEnabled } from '../../../../config/featureFlags'

const bookingsRoutes = props => [
  <PrivateRoute
    exact
    key={URL_PATHS.employeeKegCollectionBookings.path}
    path={URL_PATHS.employeeKegCollectionBookings.path}
    render={routeProps => <KegCollectionBookings {...props} {...routeProps} />}
  />,
  <PrivateRoute
    exact
    key={URL_PATHS.employeeKegCollectionBookingsDetails.path}
    path={URL_PATHS.employeeKegCollectionBookingsDetails.path}
    render={routeProps => <KegCollectionBookingsDetails {...props} {...routeProps} />}
  />,
]

// CODE_COMMENTS_26
const getRoutesList = props => [
  <PrivateRoute
    exact
    key={URL_PATHS.employeeRoot.path}
    path={URL_PATHS.employeeRoot.path}
    render={routeProps => <EmployeeDashboard {...props} {...routeProps} />}
  />,
  <PrivateRoute
    exact
    key={URL_PATHS.employeeOperateAsCustomerUser.path}
    path={URL_PATHS.employeeOperateAsCustomerUser.path}
    render={routeProps => <OperateAsCustomerUser {...props} {...routeProps} />}
  />,
  ...(isFeatureEnabled('bookings') ? bookingsRoutes(props) : []),
]

export default withRouter(props => (
    <Switch
      PrivateRoute
      exact
      path="/"
      render={() => <Redirect to={URL_PATHS.employeeRoot.path}/>}
    >
    {getRoutesList(props)}
    <RouteNotFound />
  </Switch>
))
